import script from "./OkrGradeValue.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrGradeValue.vue?vue&type=script&setup=true&lang=js"

import "./OkrGradeValue.vue?vue&type=style&index=0&id=578ca890&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578ca890"]])

export default __exports__